<template>
  <div class="login">
    <div class="login-v" v-if="screen == 'vertical'">
      <div class="login-box"></div>
    </div>
    <div class="login-h" v-else>
      <div class="login-box"></div>
    </div>
    <p class="copyright">
      Copyright©2026 360.CN All Rights Reserved 360互联网安全中心
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502062738" rel="noreferrer" target="_blank">京公网安备11010502062738号</a>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP证080047号[京ICP备08010314号-6]</a>
    </p>
  </div>
</template>

<script>
import global from "../../utils/Global";
export default {
  name: "Login",
  data () {
    return {
      screen: null,
      userInfo: global.defaultUserInfo,
    };
  },
  mounted () {
    setInterval(() => {
      if ($("body").hasClass("horizontal-screen")) {
        this.screen = "horizontal";
      } else {
        this.screen = "vertical";
      }
    }, 300);
    var ua = navigator.userAgent;
    var mobile = !!ua.match(/AppleWebKit.*Mobile.*/);
    var that = this;
    // var to_ = this.$route.params.to;
    var to_ = this.$route.query.to;
    QHPass.signIn($(".login-box"), function (e) {
      QHPass.getUserInfo(
        function (data) {
          global.userInfo = data;
          console.log("userinfo jumping", data);
          if (to_) {
            that.$router.push(to_);
          } else {
            // if (mobile) {
            //   that.$router.push("mdevice");
            // } else {
            that.$router.push("device");
            // }
          }
        },
        function (err) {
          global.userInfo = null;
          console.log("userinfo error", err);
        }
      );
    });
  },
  methods: {
    login () { },
  },
};
</script>

<style scoped>
body,
html {
  position: relative;
  width: 100%;
  min-height: 540px;
}
.login-v {
  text-align: center;
  width: 100%;
  min-height: 540px;
}
.login-v .login-box {
  padding-top: 0.4rem;
}
.login-h {
  width: 100%;
  min-height: 540px;
  height: 540px;
}
.login-h .login-box {
  width: 100%;
  min-height: 540px;
  padding-top: 0.1rem;
}
.copyright {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 12px;
  margin: 0;
  padding: 0 12px;
  font-size: 12px;
  color: #999;
  line-height: 18px;
  text-align: center;
  z-index: 10;
}
.copyright a {
  color: #999;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/page/h5/mlogin.vue